import React, { useEffect } from "react"
import "./styles.scss"

const AwardsList = ({ awards }) => {
  return (
    <div className="awards">
      {awards.map((award, i) => {
        if (award.awards.length !== 0) {
          return (
            <div key={i} className="awards__container">
              <span className="awards__year">{award.awardsYear}</span>
              <div className="awards__list">
                {award.awards.map((awardSingle, x) => {
                  return (
                    <div
                      data-sal="slide-up"
                      data-sal-easing="ease"
                      data-sal-duration="1000"
                      data-sal-delay={`${x + 1 * 100}`}
                      key={x}
                      className="award"
                    >
                      <span className="award__subtitle">
                        {awardSingle.organisation}
                      </span>
                      <h5 className="award__title">{awardSingle.name}</h5>
                      <span>{awardSingle.awardType}</span>
                    </div>
                  )
                })}
              </div>
            </div>
          )
        }
      })}
    </div>
  )
}

export default AwardsList
